import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { COLOR_STYLE } from '@src/framework/workbench/drawer/common/config';
import { textStyle } from '@framework/workbench/drawer/ui/fill/constants';

export const SCALE_DEPTH_3D_MAX = 300;

const titleStyle = {
    fontSize: '14px',
};

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.RESET_3D,
        content: '',
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.STYLE_3D,
        value: FormItemLabelName.STYLE_3D,
        style: titleStyle,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.DEPTH_3D,
        value: FormItemLabelName.DEPTH,
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_DEPTH_3D,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
            allowDecimal: true,
            toFixed: 2,
            max: SCALE_DEPTH_3D_MAX,
            min: 0,
        },
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.DEPTH_COLOR_3D,
        value: FormItemLabelName.DEPTH_COLOR_3D,
        style: textStyle,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.CHANGE_DEPTH_COLOR_3D,
        style: COLOR_STYLE,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.ROTATION,
        value: FormItemLabelName.ROTATION,
        style: titleStyle,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemLabelName.ROTATION,
        value: FormItemLabelName.ROTATION,
        style: titleStyle,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.ANGLE_X,
        value: FormItemLabelName.ANGLE_X,
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.LAYOUT_ROTATE_3D_X,
        options: {
            step: 10,
            suffix: '°',
            min: 0,
            max: 360,
            toFixed: 1,
        },
        style: {
            maxWidth: 118,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.ANGLE_Y,
        value: FormItemLabelName.ANGLE_Y,
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.LAYOUT_ROTATE_3D_Y,
        options: {
            step: 10,
            suffix: '°',
            min: 0,
            max: 360,
            toFixed: 1,
        },
        style: {
            maxWidth: 118,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.ANGLE_Z,
        value: FormItemLabelName.ANGLE_Z,
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.LAYOUT_ROTATE_3D_Z,
        options: {
            step: 10,
            suffix: '°',
            min: 0,
            max: 360,
            toFixed: 1,
        },
        style: {
            maxWidth: 118,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.CHECKBOX,
        name: FormItemName.SHOW_FLAT_TEXT,
        label: FormItemLabelName.SHOW_FLAT_TEXT,
        defaultValue: false,
        options: {
            fillType: 'tick',
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FRUSTUM_3D,
        value: FormItemLabelName.FRUSTUM_3D,
        style: {
            marginTop: '5px',
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FRONT_FRUSTUM_3D_HEIGHT,
        value: FormItemLabelName.FRONT_FRUSTUM + FormItemLabelName.FRUSTUM_HEIGHT,
        style: {
            maxWidth: 160,
        },
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_FRONT_FRUSTUM_3D_HEIGHT,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
            allowDecimal: true,
            toFixed: 2,
            max: 300,
            min: 0,
        },
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.FRONT_FRUSTUM_3D_WIDTH,
        value: FormItemLabelName.FRONT_FRUSTUM + FormItemLabelName.FRUSTUM_WIDTH,
        style: {
            maxWidth: 160,
        },
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_FRONT_FRUSTUM_3D_WIDTH,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
            allowDecimal: true,
            toFixed: 2,
            max: 300,
            min: 0,
        },
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.BACK_FRUSTUM_3D_HEIGHT,
        value: FormItemLabelName.BACK_FRUSTUM + FormItemLabelName.FRUSTUM_HEIGHT,
        style: {
            maxWidth: 160,
        },
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_BACK_FRUSTUM_3D_HEIGHT,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
            allowDecimal: true,
            toFixed: 2,
            max: 300,
            min: 0,
        },
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.BACK_FRUSTUM_3D_WIDTH,
        value: FormItemLabelName.BACK_FRUSTUM + FormItemLabelName.FRUSTUM_WIDTH,
        style: {
            maxWidth: 160,
        },
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_BACK_FRUSTUM_3D_WIDTH,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
            allowDecimal: true,
            toFixed: 2,
            max: 300,
            min: 0,
        },
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.LIGHT_3D,
        value: FormItemLabelName.LIGHT_3D,
        style: titleStyle,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.LIGHT_TYPE_3D,
        value: FormItemLabelName.LIGHT_TYPE_3D,
        style: textStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.CHANGE_3D_LIGHT_TYPE,
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.LIGHT_ROTATION,
        value: FormItemLabelName.LIGHT_ROTATION,
        style: textStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CHANGE_LIGHT_ROTATION_ANGLE,
        options: {
            step: 10,
            suffix: '°',
            min: 0,
            max: 360,
        },
        defaultValue: 0,
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.MATERIAL_3D,
        value: FormItemLabelName.MATERIAL_3D,
        style: titleStyle,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.MATERIAL_TYPE,
        value: FormItemLabelName.MATERIAL_TYPE_3D,
        style: textStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.CHANGE_MATERIAL_TYPE,
        style: {
            maxWidth: 118,
        },
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.CAMERA_PRESET_3D,
        value: FormItemLabelName.CAMERA_PRESET_3D,
        style: textStyle,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.CHANGE_CAMERA_PRESET,
        style: {
            minWidth: i18n.language === 'en-US' ? '200px' : '0px',
            maxWidth: 118,
        },
    },
];
